import { render, staticRenderFns } from "./AddAoaiKeyVault.vue?vue&type=template&id=73f0fffc&scoped=true&"
import script from "./AddAoaiKeyVault.vue?vue&type=script&lang=js&"
export * from "./AddAoaiKeyVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0fffc",
  null
  
)

export default component.exports